/**
 * @file Contains the definition of maps help with file generator
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import comment from './Lin21GeneratorComment';

/**
 * Mapping state to prefix text
 * The value is prefix text for each variable in Option.txt file
 * The key is the state name
 * The prefix with '###' to comment out means we don't provide
 * things in the generator to modify it yet, it'll take default value.
 * Remove '###' to enable the variable and change the default value of its corresponding state
 * @type {Map}
 */
export const state2PrefixMap = new Map([
    ['licenseAgreementAccept', 'licenseAgreement.accept='],
    //userRegistration
    ['userRegistrationUser', 'userRegistration.user='],
    ['userRegistrationCompany', 'userRegistration.company='],
    ['userRegistrationCdKey', 'userRegistration.cdKey='],

    ['installInstance', 'install.Instance='],
    ['installOperation', 'install.Operation='],
    //Destination Location
    ['suiteHomeDirectory', 'suite.homeDirectory='],
    ['suiteInstallDirectory', 'suite.installDirectory='],
    ['suiteLogDirectory', 'suite.logDirectory='],
    //Select Components
    ['intelligenceActive', 'Intelligence.active='],
    ['reportServicesActive', 'ReportServices.active='],
    ['oLAPServicesActive', 'OLAPServices.active='],
    ['distributionServicesActive', 'DistributionServices.active='],
    ['transactionServicesActive', 'TransactionServices.active='],
    ['webReporterActive', 'WebReporter.active='],
    ['webAnalystActive', 'WebAnalyst.active='],
    ['webProfessionalActive', 'WebProfessional.active='],
    ['gISConnectorsActive', 'GISConnectors.active='],
    ['mobileServerActive', 'MobileServer.active='],
    ['communityConnectorsActive', 'CommunityConnectors.active='],
    ['commandManagerActive', 'CommandManager.active='],
    ['systemManagerActive', 'SystemManager.active='],
    ['platformAnalyticsActive', 'PlatformAnalytics.active='],
    ['enterpriseManagerActive', 'EnterpriseManager.active='],
    ['integrityManagerActive', 'IntegrityManager.active='],
    ['telemetryServerActive', 'TelemetryServer.active='],
    ['libraryWebMobileActive', 'LibraryWebMobile.active='],
    ['collaborationActive', 'Collaboration.active='],
    ['certificateStoreActive', 'CertificateStore.active='],
    ['exportActive', 'Export.active='],
    ['repositoryActive', 'Repository.active='],
    ['cloudObjectConnectorActive', 'CloudObjectConnector.active='],
    ['storageServiceActive', 'StorageService.active='],
    ['tomcatActive', 'Tomcat.active='],
    //Directory Settings
    ['webUniversalDeployDirectory', 'WebUniversal.deployDirectory='],
    ['gISConnectorsInstallDirectory', 'GISConnectors.installDirectory='],
    [
        'communityConnectorsInstallDirectory',
        'CommunityConnectors.installDirectory=',
    ],
    ['mobileServerInstallDirectory', 'MobileServer.installDirectory='],
    ['commandManagerInstallDirectory', 'CommandManager.installDirectory='],
    ['systemManagerInstallDirectory', 'SystemManager.installDirectory='],
    [
        'platformAnalyticsInstallDirectory',
        'PlatformAnalytics.installDirectory=',
    ],
    //CPU
    ['cpuCountNumber', '### cpuCount.number='],
    //Remote Repository
    ['remoteRepositoryDBHost', 'RemoteRepository.DBHost='],
    ['remoteRepositoryDBPort', 'RemoteRepository.DBPort='],
    ['remoteRepositoryDBUser', 'RemoteRepository.DBUser='],
    ['remoteRepositoryDBPassword', 'RemoteRepository.DBPassword='],
    //Repository Upgrade
    ['repositoryUpgradeConfirm', '### Repository.upgrade.confirm='],
    ['repositoryDBPort', '### Repository.DBPort='],
    ['repositoryDBUser', '### Repository.DBUser='],
    ['repositoryDBPassword', '### Repository.DBPassword='],
    ['platformAnalyticsOverrideDb', 'PlatformAnalytics.overrideDb='],
    ['collaborationOverrideDb', 'Collaboration.overrideDb='],
    ['storageServiceOverrideDb', 'StorageService.overrideDb='],
    [
        'storageServiceOverwriteDbConnectionInfo',
        '### StorageService.overwrite.DBConnectionInfo=',
    ],
    //Telemetry Server
    ['telemetryServerClusterEnable', 'TelemetryServer.cluster.enable='],
    ['telemetryServerClusterLocalnode', 'TelemetryServer.cluster.localnode='],
    [
        'telemetryServerClusterRemotenodes',
        'TelemetryServer.cluster.remotenodes=',
    ],
    //Topology Configuration
    [
        'servicesRegistrationMachineEnvironment',
        'ServicesRegistration.machine.environment=',
    ],
    ['servicesRegistrationServerHosts', 'ServicesRegistration.serverHosts='],
    //Registering as a service
    ['registerServices', 'RegisterServices='],
    ['registerServicesUser', 'RegisterServices.user='],
    ['registerServicesGroup', 'RegisterServices.group='],
    //Product Visibility
    ['intelligenceVisible', '### Intelligence.visible='],
    ['reportServicesVisible', '### ReportServices.visible='],
    ['oLAPServicesVisible', '### OLAPServices.visible='],
    ['distributionServicesVisible', '### DistributionServices.visible='],
    ['transactionServicesVisible', '### TransactionServices.visible='],
    ['webReporterVisible', '### WebReporter.visible='],
    ['webAnalystVisible', '### WebAnalyst.visible='],
    ['webProfessionalVisible', '### WebProfessional.visible='],
    ['gISConnectorsVisible', '### GISConnectors.visible='],
    ['mobileServerVisible', '### MobileServer.visible='],
    ['communityConnectorsVisible', '### CommunityConnectors.visible='],
    ['commandManagerVisible', '### CommandManager.visible='],
    ['integrityManagerVisible', '### IntegrityManager.visible='],
    ['systemManagerVisible', '### SystemManager.visible='],
    ['platformAnalyticsVisible', '### PlatformAnalytics.visible='],
    ['enterpriseManagerVisible', '### EnterpriseManager.visible='],
    ['telemetryServerVisible', '### TelemetryServer.visible='],
    ['libraryWebMobileVisible', '### LibraryWebMobile.visible='],
    ['collaborationVisible', '### Collaboration.visible='],
    ['certificateStoreVisible', '### CertificateStore.visible='],
    ['exportVisible', '### Export.visible='],
    ['repositoryVisible', '### Repository.visible='],
    ['cloudObjectConnectorVisible', '### CloudObjectConnector.visible='],
    ['storageServiceVisible', '### StorageService.visible='],
    ['tomcatVisible', '### Tomcat.visible='],

    ['installOnDemandStyle', '### InstallOnDemand.style='],
    ['installOnDemandSourceLocation', '### InstallOnDemand.sourceLocation='],
    ['installOnDemandUrl', '### InstallOnDemand.url='],
    [
        'installOnDemandBypassCertificateChecking',
        '### InstallOnDemand.bypassCertificateChecking=',
    ],
    ['installOnDemandUser', '### InstallOnDemand.user='],
    ['installOnDemandPassword', '### InstallOnDemand.password='],
]);

/**
 * Mapping the comments that should appear before each prefix text
 * The key is prefix text for each variable in Option.txt file
 * The value is the comments content
 * @type {Map}
 */
export const state2CommentMap = new Map([
    ['licenseAgreementAccept', comment.licenseAgreementAccept],
    //userRegistration
    ['userRegistrationUser', comment.userRegistrationUser],
    ['userRegistrationCompany', comment.userRegistrationCompany],
    ['userRegistrationCdKey', comment.userRegistrationCdKey],

    ['installInstance', comment.installInstance],
    ['installOperation', comment.installOperation],
    //Destination Location
    ['suiteHomeDirectory', comment.suiteHomeDirectory],
    ['suiteInstallDirectory', ''],
    ['suiteLogDirectory', ''],
    //Select Components
    ['intelligenceActive', comment.intelligenceActive],
    ['reportServicesActive', comment.reportServicesActive],
    ['oLAPServicesActive', comment.oLAPServicesActive],
    ['distributionServicesActive', comment.distributionServicesActive],
    ['transactionServicesActive', comment.transactionServicesActive],

    ['webReporterActive', comment.webReporterActive],
    ['webAnalystActive', comment.webAnalystActive],
    ['webProfessionalActive', comment.webProfessionalActive],
    ['gISConnectorsActive', comment.gISConnectorsActive],

    ['mobileServerActive', comment.mobileServerActive],
    ['communityConnectorsActive', comment.communityConnectorsActive],
    ['commandManagerActive', comment.commandManagerActive],
    ['systemManagerActive', comment.systemManagerActive],
    ['platformAnalyticsActive', comment.platformAnalyticsActive],
    ['enterpriseManagerActive', comment.enterpriseManagerActive],
    ['integrityManagerActive', comment.integrityManagerActive],

    ['telemetryServerActive', comment.telemetryServerActive],
    ['libraryWebMobileActive', comment.libraryWebMobileActive],
    ['collaborationActive', comment.collaborationActive],
    ['certificateStoreActive', comment.certificateStoreActive],
    ['exportActive', comment.exportActive],
    ['repositoryActive', comment.repositoryActive],
    ['cloudObjectConnectorActive', comment.cloudObjectConnectorActive],
    ['storageServiceActive', comment.storageServiceActive],
    ['tomcatActive', comment.tomcatActive],
    //Directory Settings
    ['webUniversalDeployDirectory', comment.webUniversalDeployDirectory],
    ['gISConnectorsInstallDirectory', comment.gISConnectorsInstallDirectory],
    [
        'communityConnectorsInstallDirectory',
        comment.communityConnectorsInstallDirectory,
    ],
    ['mobileServerInstallDirectory', comment.mobileServerInstallDirectory],
    ['commandManagerInstallDirectory', comment.commandManagerInstallDirectory],
    ['systemManagerInstallDirectory', comment.systemManagerInstallDirectory],
    [
        'platformAnalyticsInstallDirectory',
        comment.platformAnalyticsInstallDirectory,
    ],
    //CPU
    ['cpuCountNumber', comment.cpuCountNumber],
    //Remote Repository
    ['remoteRepositoryDBHost', comment.remoteRepositoryDBHost],
    ['remoteRepositoryDBPort', ''],
    ['remoteRepositoryDBUser', ''],
    ['remoteRepositoryDBPassword', ''],
    //Repository Upgrade
    ['repositoryUpgradeConfirm', comment.repositoryUpgradeConfirm],
    ['repositoryDBPort', ''],
    ['repositoryDBUser', ''],
    ['repositoryDBPassword', ''],
    ['platformAnalyticsOverrideDb', comment.platformAnalyticsOverrideDb],
    ['collaborationOverrideDb', comment.collaborationOverrideDb],
    ['storageServiceOverrideDb', comment.storageServiceOverrideDb],
    ['storageServiceOverwriteDbConnectionInfo', ''],
    //Telemetry Server
    ['telemetryServerClusterEnable', comment.telemetryServerClusterEnable],
    [
        'telemetryServerClusterLocalnode',
        comment.telemetryServerClusterLocalnode,
    ],
    [
        'telemetryServerClusterRemotenodes',
        comment.telemetryServerClusterRemotenodes,
    ],
    //Topology Configuration
    [
        'servicesRegistrationMachineEnvironment',
        comment.servicesRegistrationMachineEnvironment,
    ],
    [
        'servicesRegistrationServerHosts',
        comment.servicesRegistrationServerHosts,
    ],
    //Registering as a service
    ['registerServices', comment.registerServices],
    ['registerServicesUser', comment.registerServicesUser],
    ['registerServicesGroup', ''],
    ['intelligenceVisible', comment.intelligenceVisible],
    ['reportServicesVisible', comment.reportServicesVisible],
    ['oLAPServicesVisible', comment.oLAPServicesVisible],
    ['distributionServicesVisible', comment.distributionServicesVisible],
    ['transactionServicesVisible', comment.transactionServicesVisible],
    ['webReporterVisible', comment.webReporterVisible],
    ['webAnalystVisible', comment.webAnalystVisible],
    ['webProfessionalVisible', comment.webProfessionalVisible],
    ['gISConnectorsVisible', comment.gISConnectorsVisible],
    ['mobileServerVisible', comment.mobileServerVisible],
    ['communityConnectorsVisible', comment.communityConnectorsVisible],
    ['commandManagerVisible', comment.commandManagerVisible],
    ['integrityManagerVisible', comment.integrityManagerVisible],
    ['systemManagerVisible', comment.systemManagerVisible],
    ['platformAnalyticsVisible', comment.platformAnalyticsVisible],
    ['enterpriseManagerVisible', comment.enterpriseManagerVisible],
    ['telemetryServerVisible', comment.telemetryServerVisible],
    ['libraryWebMobileVisible', comment.libraryWebMobileVisible],
    ['collaborationVisible', comment.collaborationVisible],
    ['certificateStoreVisible', comment.certificateStoreVisible],
    ['exportVisible', comment.exportVisible],
    ['repositoryVisible', comment.repositoryVisible],
    ['cloudObjectConnectorVisible', comment.cloudObjectConnectorVisible],
    ['storageServiceVisible', comment.storageServiceVisible],
    ['tomcatVisible', comment.tomcatVisible],

    ['installOnDemandStyle', comment.installOnDemandStyle],
    ['installOnDemandSourceLocation', comment.installOnDemandSourceLocation],
    ['installOnDemandUrl', comment.installOnDemandUrl],
    [
        'installOnDemandBypassCertificateChecking',
        comment.installOnDemandBypassCertificateChecking,
    ],
    ['installOnDemandUser', comment.installOnDemandUser],
    ['installOnDemandPassword', comment.installOnDemandPassword],
]);
